import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { BaseService } from './../../../shared-service/base.service';
import { OverviewService } from '../overview.service';
import { WindowRef } from '../../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'timeline-conversation',
  templateUrl: './timeline-conversation.component.html',
  styleUrls: ['./timeline-conversation.component.css']
})
export class TimeLineConversationComponent implements OnInit {
  @Input() Comments: Array<object>|any = [];
  @Input() TileId: number=0;
  @Input() UserThumbnail: string="";
  CommentList: Array<any> = [];
  ShowButton: boolean = true;
  ShowMore: boolean = false;
  paramsComments: object|any = {};
  TempCmt: Object|any = {};
  NumberOfMoreComment: number = 0;
  UserId: number = 0;
  ConversationId: number = 0;
  CommentListObject: Array<object> = [];
  ShowLessButton: boolean = false;

  UserName: string = "";
  ValidationMsg: boolean = false;

  // @Output() count: EventEmitter<string> = new EventEmitter<string>();
  NumberOfComments: number = 0;
  constructor(private os: OverviewService, public bs: BaseService ,private winRef: WindowRef) {
    this.paramsComments = {
      'TileId': 0,
      'UserId': 0,
      'ConversationId': 0,
      'ConversationText': '',
      'Flag': '',
      'recordsCount': 0,
      'pageNumber': 1,
      'Type': '',
      'Commentcount': 0
    };

    this.TempCmt = {
      'CommentList': null,
      'TileId': 0,
      'ConversationId': 0,
      'ConversationText': "",
      'UserId': 0,
      'UserName': "",
      'UserThumbnail': "",
      'PostedDate': "",
      'IsEditable': false,
      'PostedDuration': "",
      'LikeCount': 0,
      'IsLiked': false,
      'IsReportedAbuse': false,
      'NumberOfMoreComment': 0,
      'PageNumber': 0,
      'RecordsCount': 0,
      'TotalRecords': 0
    };
  }

  ngOnInit() {
    if (this.Comments.length > 0) {
      this.CommentList = this.Comments;
      this.CommentListObject = this.Comments;
      this.NumberOfMoreComment = this.Comments[0]["NumberOfMoreComment"];
      this.TileId = this.Comments[0]["TileId"];
      this.ConversationId = this.Comments[0]["ConversationId"];
      this.UserId = this.Comments[0]["UserId"];
      this.UserName = this.Comments[0]["UserName"];
      this.UserId = this.Comments[0]["UserId"];

      this.NumberOfComments = this.Comments[0]["NumberOfMoreComment"] - 1;
      if (this.NumberOfComments > 0) {
        this.ShowButton = true;
      }
      else {
        this.ShowButton = false;
      }
    }
  }

  //loading 5 comments when user click on show more comment link
  showMoreComments(TileId: number, ConversationId: number, UserId: number): void {
    this.paramsComments['recordsCount'] = 5;
    this.paramsComments['TileId'] = TileId;
    this.paramsComments['UserId'] = UserId;
    this.paramsComments['UserID'] = this.bs.getUserAttr('UserId');
    this.paramsComments['ConversationId'] = ConversationId;
    if (this.ShowMore == true) {
      this.paramsComments['pageNumber'] += 1;
    }
    this.os.getMoreComments(this.paramsComments, "****").then((data:any) => {
      if (data["TimeLineConversationList"] != null) {
        this.Comments = this.Comments.concat(data["TimeLineConversationList"]);
        this.CommentList = this.Comments;
        if (((this.CommentList.length) - 1) == data["TotalRecords"]) {
          this.ShowButton = false;
          this.ShowLessButton = true;
        }
        else {
          this.ShowButton = true;
        }
      }
      else {
        this.ShowButton = false;
      }
      this.ShowMore = true;
    }, (data) => {
      this.bs.log('error', 'Error in getting list');
    });
  }

  showLessComments() {
    this.Comments = this.CommentListObject
    this.CommentList = this.Comments;;
    this.NumberOfMoreComment = this.Comments[0]["NumberOfMoreComment"];
    this.TileId = this.Comments[0]["TileId"];
    this.ConversationId = this.Comments[0]["ConversationId"];
    this.UserId = this.Comments[0]["UserId"];
    this.UserName = this.Comments[0]["UserName"];
    this.UserId = this.Comments[0]["UserId"];
    this.ShowButton = true;
    this.ShowLessButton = false;
    this.paramsComments['pageNumber'] = 0;
  }


  AddUpdateDeleteComment(){
    this.os.AddUpdateDeleteComment(this.paramsComments, "****").then((data:any) => {        
        this.CommentList = data["TimeLineConversationList"]
        this.Comments=this.CommentList; 
        this.CommentListObject = data["TimeLineConversationList"]
        this.NumberOfMoreComment = this.CommentList[0]["NumberOfMoreComment"];
        this.TileId = this.CommentList[0]["TileId"];
        this.ConversationId = this.CommentList[0]["ConversationId"];
        this.UserId = this.CommentList[0]["UserId"];
        this.UserName = this.CommentList[0]["UserName"];
        this.UserId = this.CommentList[0]["UserId"];  
        this.NumberOfComments = this.CommentList[0]["NumberOfMoreComment"] - 1;
        if (this.NumberOfComments > 0) {
          this.ShowButton = true;
          this.ShowMore=true;
          this.paramsComments['pageNumber'] = 0;
        }
        else {
          this.ShowButton = false;
          this.ShowMore=false;
          this.paramsComments['pageNumber'] = 1;
        }
        this.ShowLessButton = false;
     
    }, (data) => {
      this.bs.log('error', 'Error in getting list');
    });

    return false;
  }

  //saving and validating comment edit by user and pushing the updated value in object on a particular index 
  EditComment(TileId: number, ConversationId: Number, Index: number): boolean {
    if ($('#Text' + ConversationId).val().trim() == "") {
      this.winRef.nativeWindow.document.getElementById("CmtValdiation" + ConversationId).style.display = '';
      $("#Text" + ConversationId).addClass("reuiredtext");
      return false;
    }
    else {
      this.winRef.nativeWindow.document.getElementById("CmtValdiation" + ConversationId).style.display = 'none';
      $("#Text" + ConversationId).removeClass("reuiredtext");
    }
    this.paramsComments['ConversationId'] = ConversationId;
    this.paramsComments['ConversationText'] = $('#Text' + ConversationId).val();
    this.paramsComments['TileId'] = TileId;
    this.paramsComments['Flag'] = 'U';
    this.AddUpdateDeleteComment();
    this.winRef.nativeWindow.document.getElementById("Comment" + ConversationId).style.display = '';
    return false;
  }

  //saving and validating comment fields 
  AddComment(TileId: number, UserId: number) {
    if ($('#txtAdd' + TileId).val().trim() == "") {
      $('#txtAdd' + TileId).addClass("reuiredtext");
      this.ValidationMsg = true;
      return false;
    }
    else {
      this.ValidationMsg = false;
      $('#txtAdd' + TileId).removeClass("reuiredtext");
    }

    this.paramsComments['TileId'] = TileId;
    this.paramsComments['UserId'] = UserId;
    this.paramsComments['ConversationText'] = $('#txtAdd' + TileId).val();
    this.paramsComments['UserID'] = this.bs.getUserAttr('UserId');
    this.paramsComments['Flag'] = 'I';
    this.AddUpdateDeleteComment();
    $('#txtAdd' + TileId).val('');
    $('#Review' + TileId)[0].textContent = parseInt($('#Review' + TileId)[0].innerHTML) + 1;

    return false;
  }
  //to display text box when user edit his / her comments
  EditElements(ConversationId: Number): boolean {
    this.winRef.nativeWindow.document.getElementById('Text' + ConversationId).innerHTML = this.winRef.nativeWindow.document.getElementById("ConversationText" + ConversationId).innerHTML.trim();
    this.winRef.nativeWindow.document.getElementById("Comment" + ConversationId).style.display = 'none';
    this.winRef.nativeWindow.document.getElementById("Thread" + ConversationId).style.display = '';
    return false;
  }
  //deleting comments removing it from object and checking for the latest comment of logged in user
  DeleteComment(Index: number, ConversationId: number, TileId: number, UserId: number): boolean {
    if (confirm(this.bs.getResource("rbkey_CnvrstnCmmntDltMSG")) == false) {
      return false;
    }

    this.paramsComments['ConversationId'] = ConversationId;
    this.paramsComments['TileId'] = TileId;
    this.paramsComments['UserId'] = UserId;
    this.paramsComments['UserID'] = this.bs.getUserAttr('UserId');
    this.paramsComments['Flag'] = 'D';
    this.AddUpdateDeleteComment();

    $('#Review' + TileId)[0].textContent = parseInt($('#Review' + TileId)[0].innerHTML) - 1;
    return false;
  }
  //Like Section
  LikeConversation(item: Object[]|any, Index: number) {
    if (item["UserId"] != this.bs.getUserAttr('UserId')) {
      this.paramsComments['ConversationId'] = item['ConversationId'];
      this.paramsComments['TileId'] = item['TileId'];
      this.paramsComments['UserId'] = this.bs.getUserAttr('UserId');
      this.os.LikeUpdateOverTimeLineConversation(this.paramsComments, "****").then((data:any) => {
        setTimeout(() => {
          this.CommentList[Index]["LikeCount"] = data["LikeCount"];
          this.CommentList[Index]["IsLiked"] = data["IsLiked"];
          if (Index = 0) {
            this.TempCmt["IsLiked"] = data["IsLiked"];
          }
          if (data["IsLiked"]) {
            $('#Like' + item["ConversationId"]).addClass('fa-thumbs-up-blue');
          }
          else {
            $('#Like' + item["ConversationId"]).removeClass('fa-thumbs-up-blue');
          }
        }, 200);
      },
        (data) => {
        });
      return false;
    }
  }
  //Reported Abuse Section
  ReportAbuseConversation(item: Object[]|any, Index: number) {
    if (item['IsReportedAbuse']) {
      alert(this.bs.getResource('rbkey_RprtAbsMSG'));
      return false;
    }
    else {
      var message = prompt(this.bs.getResource('rbkey_RprtAbsPrmptMSG'));
      if (message != null) {
        var msgLenght = message.length;
        if (msgLenght == 0) {
          alert(this.bs.getResource('rbkey_RprtAbsVldtMSG'));
          return false;
        }
        if (msgLenght > 250) {
          alert(this.bs.getResource('rbkey_RprtAbsLnthMSG'));
          return false;
        }
        else {
          this.paramsComments['ItemId'] = item['ConversationId'];
          this.paramsComments['TileId'] = item['TileId'];
          this.paramsComments['ItemType'] = 'TC';
          this.paramsComments['UserID'] = this.bs.getUserAttr('UserId');
          this.paramsComments['PostedContentUserId'] = item['UserId'];;
          this.paramsComments['ReportAbuseComment'] = message;
          this.os.SetTimeLineReportedAbuseComment(this.paramsComments, "****").then((data) => {
            setTimeout(() => {
              this.CommentList[Index]["IsReportedAbuse"] = true;
            }, 200);
          },
            (data) => {
            });
          setTimeout(() => {
            $('#ReportAbuse' + item["ConversationId"]).addClass('fa-flag-red');
          }, 300);
          return false;
        }
      }
    }

  }
}




